<script>
    import Svg from "./Svg.svelte";

    /**
     * The x position of the upper left corner
    */
    export let x;

   /**
    * The y position of the upper left corner
   */
    export let y;

    /**
     * Is the tooltip currently visible?
    */
    export let visible;

    /**
     * Are we rendering this for mobile?
    */
    export let isMobile;

    /**
     * The width of the tooltip container, in pixels
    */
    export let width = 250;

    /**
     * The ID of the element
    */
    export let id = "g-tooltip";

    $: stylePos = `left: ${x}px; top: ${y}px; width: ${width}px;`;
    $: style = !visible ? "display: none;" : isMobile ? "" : stylePos;

</script>

<div class="g-tip"
    id={id}
    class:g-tip-mobile={isMobile}
    style={style}
    role="tooltip"
    aria-hidden={!visible}
    on:mouseover={() => visible = true}
>
    <span aria-label="Tooltip: "></span>
    {#if isMobile}
    <button on:click={() => {visible = false;}} class="g-tip-button" type="button" aria-label="Close tooltip">
        <Svg width={18} height={18} role="presentation">
            <line x1="0" x2="18" y1="0" y2="18"></line>
            <line x1="18" y1="0" x2="0" y2="18"></line>
        </Svg>
    </button>
    {/if}
    <div class="g-tip-content">
        <slot></slot>
    </div>
</div>

<style>
    .g-tip {
        position: fixed;
        border: 1px solid #eee;
        border-radius: 3px;
        background: #fff;
        z-index: 100;
        font-size: 0.7rem;
        box-shadow: 1px 1px 5px rgba(0,0,0,.25);
        padding: 1em 1.32;
        pointer-events: none;
    }

    .g-tip-mobile {
        left: 0;
        position: fixed;
        width: 100%;
        bottom: 0;
        border: none;
        border-radius: 0;
        box-shadow: 0 0 2px rgba(0,0,0,0.5);
    }

    .g-tip-button {
        border: none;
        position: absolute;
        right: 3px;
        top: 3px;
        width: 35px;
        height: 35px;
    }

    .g-tip-button line {
        stroke: #616161;
        stroke-width: 2;
    }
</style>